import {
  Box,
  Typography,
  Button,
  Grid,
  Container,
  Divider,
  Tab,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Slide,
  useTheme,
  useMediaQuery,
} from '@mui/material'

import React, { forwardRef, useEffect, useState } from 'react'
import Carousel from 'react-material-ui-carousel'
import WTypography from '../../../../Components/whiteTypography'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { useParams, useNavigate } from 'react-router-dom'
import { UTILISATION } from 'utils/constants'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'

import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import Link from '@mui/material/Link'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import AttachmentIcon from '@mui/icons-material/Attachment'

import CreateDocumentsForm from '../../../../Components/CreateDocumentsForm'

import CalendarView from 'Components/CalendarView'

import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import ListTop from './ListTop'
import ListBottom from './ListBottom'
import EditIcon from '@mui/icons-material/Edit'
import CreateEventForm from './CreateEventForm'
import EventViewForm from './EventViewForm'
import { makePostRequest } from 'utils/api'
import CustomButton from 'Components/CustomButton/CustomButton'
import UpdateVehicle from './UpdateVehicle'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import styled from '@emotion/styled'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { VehicleImgUploadForm } from './VehicleImgUploadForm'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

const useStyles = styled((theme) => ({
  contactBox: {
    display: 'flex',
    // justifyContent: 'center',
    padding: '10px 0px',
    alignItems: 'center',
    marginLeft: '20px',
  },
}))

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
export const VehicleDetails = () => {
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { id } = useParams()
  const classes = useStyles()
  const [upload, setUpload] = useState(false)

  const [document, setDocument] = useState({})
  const [vehicule, setVehicule] = useState({})
  const [value, setValue] = React.useState('1')
  const [operations, setOperations] = useState({})
  const [operationsH, setOperationsH] = useState({})
  const [eventF, setEventF] = useState(false)
  const [eventViewF, setEventViewF] = useState(false)
  const [open, setOpen] = useState(false)
  const [openAContactForm, setOpenAContactForm] = useState(false)
  const [field, setField] = useState('')
  const [selected, setSelected] = React.useState([])
  const [files, setFiles] = useState(null)

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }

  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteVehicleContacts,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchVehicleDetail()
        setSelected([])
      }
    }
  }
  let navigate = useNavigate()

  useEffect(() => {
    fetchVehicleDetail()
    fetchEntretienHistoriques()
    fetchOperations()
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const upload_vehicle_picture = () => {
    if (files) {
      const filearr = Array.from(files)
      filearr.forEach(async (f) => {
        let formData = new FormData()
        let url = '/api/domicile/upload-vehicle-picture/'
        if (f != null) formData.append('image', f)
        formData.append('id', id)
        const response = await makePostRequest(
          url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
          true,
        )
        if (response.status === 200) {
          // const filterItems = items.filter((v) => v.id !== null)
          // setItems([...filterItems, response.data])
          fetchVehicleDetail()
          handleCloseDialog()
        }
      })
    }
  }
  const handleCloseDialog = () => {
    setUpload(false)
    setFiles(null)
  }
  const fetchVehicleDetail = async () => {
    const response = await makeGetRequest(urls.crudVehiclesOperations + id, {}, true)
    if (response.status === 200) {
      setVehicule(response.data)
    }
  }

  const displayColumn = (name, value, postfix = '', Icone = '', handelClick = null) => (
    <Box>
      {name === 'Statut' ? (
        <Typography
          variant="h6"
          sx={{
            color: value === 'Actif' ? 'green' : value === 'Inactif' ? 'red' : 'unset',
          }}
        >
          {value}
        </Typography>
      ) : (
        <WTypography variant="h6">
          {value || 'N/A'} {postfix || ''}
        </WTypography>
      )}
      {Icone ? (
        <Typography color="secondary">
          {name} <Icone />
        </Typography>
      ) : (
        <Typography color="secondary">{name}</Typography>
      )}
    </Box>
  )
  function HistoriqueKmEditicone() {
    const historiquekm = () => {
      navigate(`/domicile/historiquekm/vehicule/${vehicule.id}`)
    }
    return (
      <>
        <EditIcon onClick={historiquekm} cursor={'pointer'} fontSize={'inherit'} color={'white'} />
      </>
    )
  }
  function ChangeValueEditiconeConso() {
    return (
      <>
        <EditIcon
          onClick={() => {
            setOpen(true)
            setField('Consommation')
          }}
          cursor={'pointer'}
          fontSize={'inherit'}
          color={'white'}
        />
      </>
    )
  }
  function ChangeValueEditiconePuissance() {
    return (
      <>
        <EditIcon
          onClick={() => {
            setOpen(true)
            setField('Puissance')
          }}
          cursor={'pointer'}
          fontSize={'inherit'}
          color={'white'}
        />
      </>
    )
  }
  function ChangeValueEditiconeGénération() {
    return (
      <>
        <EditIcon
          onClick={() => {
            setOpen(true)
            setField('Génération')
          }}
          cursor={'pointer'}
          fontSize={'inherit'}
          color={'white'}
        />
      </>
    )
  }
  function ChangeValueEditiconeVersion() {
    return (
      <>
        <EditIcon
          onClick={() => {
            setOpen(true)
            setField('Version')
          }}
          cursor={'pointer'}
          fontSize={'inherit'}
          color={'white'}
        />
      </>
    )
  }
  function DetailDepenseEditicone() {
    const detaildepense = () => {
      navigate(`/domicile/detaildepense/vehicule/${vehicule.id}`)
    }
    return (
      <>
        <EditIcon onClick={detaildepense} cursor={'pointer'} fontSize={'inherit'} color={'white'} />
      </>
    )
  }

  const fetchOperations = async (pagination = '') => {
    // setLoading(true)
    let url = `${
      urls.crudEntretienRealiserOperations + `?vid=${id}&Done=false&page=vehicule&Schedule=Oui`
    }`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      // setLoading(false)
    }
    // setLoading(false)
  }
  const fetchEntretienHistoriques = async (pagination = '') => {
    // setLoading(true)
    let url = `${
      urls.crudEntretienRealiserOperations + `?vid=${id}&Done=false&page=vehicule&Schedule=Non`
    }`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsH({ ...response.data })
      // setLoading(false)
    }
    // setLoading(false)
  }

  function HistoriqueValoEditicone() {
    const historiquevalo = () => {
      navigate(`/domicile/historiquevalo/vehicule/${vehicule.id}`)
    }
    return (
      <>
        <EditIcon
          onClick={historiquevalo}
          cursor={'pointer'}
          fontSize={'inherit'}
          color={'white'}
        />
      </>
    )
  }
  function FinancementEditicone() {
    const financement = () => {
      navigate(`/domicile/financement/vehicule/${vehicule.id}`)
    }
    return (
      <>
        <EditIcon onClick={financement} cursor={'pointer'} fontSize={'inherit'} color={'white'} />
      </>
    )
  }

  const informationGenerales = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Informations générales</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        <Box>{displayColumn('Statut', vehicule.Statut)}</Box>
        <Box>{displayColumn('Kilomètres', vehicule.KLMT, '', HistoriqueKmEditicone)}</Box>
        <Box>{displayColumn('Date de vente', vehicule.DateSale)}</Box>
      </Box>
    </Box>
  )

  const caracteristiquestechniques = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Caractéristiques techniques</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        <Box>
          {displayColumn('Consommation', vehicule.Conso, 'l/100 km', ChangeValueEditiconeConso)}
        </Box>
        {vehicule.Motortypes ? (
          <Box>{displayColumn('Type de moteur', vehicule.Motortypes.motor_type)}</Box>
        ) : (
          ''
        )}
        {vehicule.vehicletypes ? (
          <Box>{displayColumn('Type de véhicule', vehicule.vehicletypes.vehicletype)}</Box>
        ) : (
          ''
        )}
      </Box>
      {/* <Box display={'flex'} flexWrap="wrap"  px={4} py={1}> */}
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        {vehicule.Models ? (
          <Box>
            {displayColumn('Puissance', vehicule.Puissance, ' cv', ChangeValueEditiconePuissance)}
          </Box>
        ) : (
          ''
        )}
        <Box>{displayColumn('Emission', vehicule.Models?.Emission, ' t CO2 / an')}</Box>
        {vehicule.Models ? (
          <Box>
            {displayColumn('Génération', vehicule.Generation, '', ChangeValueEditiconeGénération)}
          </Box>
        ) : (
          ''
        )}
      </Box>
      <Box display={'flex'} flexWrap="wrap" px={4} py={1}>
        {vehicule.Models ? (
          <Box>{displayColumn('Version', vehicule.Version, '', ChangeValueEditiconeVersion)}</Box>
        ) : (
          ''
        )}
      </Box>
    </Box>
  )

  const informationsfinancieres = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Informations financières</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        <Box>
          {displayColumn('Valeurs marché', vehicule.Vhvalue, ' €', HistoriqueValoEditicone)}
        </Box>
        <Box>
          {displayColumn(
            'Date valorisation',
            convertToUserDateFormate(siteUser.user, vehicule.DateValue),
          )}
        </Box>
        <Box>{displayColumn('Charges', vehicule.Expense, ' €', DetailDepenseEditicone)}</Box>
      </Box>
      <Box display={'flex'} flexWrap="wrap" px={4} py={1}>
        <Box width={'44.4%'}>
          {displayColumn('Reste a payer', vehicule.RestToPay, ' €', FinancementEditicone)}
        </Box>
        <Box>
          {displayColumn(
            'Date d’acquisition',
            convertToUserDateFormate(siteUser.user, vehicule.DatePurch),
          )}
        </Box>
      </Box>
    </Box>
  )

  const contact = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <Box sx={{ display: 'flex', pb: 3 }}>
        <WTypography variant="h6">Contact</WTypography>
        <Box sx={{ marginLeft: 'auto' }}>
          <CustomButton onClick={() => setOpenAContactForm(true)}>Ajouter</CustomButton>
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>

      <Box>
        {vehicule?.contactsList?.map((row, index) => (
          <Box
            key={row.id}
            sx={{ display: 'flex', '.MuiCheckbox-root': { color: 'white !important' } }}
          >
            <Checkbox
              onClick={(event) => handleClick(event, row.id)}
              color="secondary"
              inputProps={{
                'aria-labelledby': index,
              }}
            />
            <Box
              className={classes.contactBox}
              onClick={() => navigate(`/MesContacts?cid=${row.contact}`)}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Avatar sx={{ marginRight: '10px' }} alt="" src={row.contactObj?.Picture} />
              <WTypography>
                {row.contactObj?.Titres?.Titre}. {row.contactObj?.Nom} --------- {row.role}
              </WTypography>
            </Box>
          </Box>
        ))}
        {vehicule?.contactsList?.length === 0 && <Box sx={{ color: 'white' }}>No contact</Box>}
      </Box>

      {/* {document.utilisation === '2' ? (
        <WTypography>{financeInformation.bailleur} Bailleur</WTypography>
      ) : (
        <WTypography>{financeInformation.responsable} Responsable</WTypography>
      )} */}
    </Box>
  )

  const documents = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      {/* <WTypography variant="h6">Documents</WTypography> */}

      {/* <WTypography> Coming soon</WTypography> */}
      <BasicTable />
    </Box>
  )
  const plandentretien = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      {operations.results?.length > 0 ? (
        <>
          <WTypography
            variant="h6"
            onClick={() =>
              navigate(`/domicile/entretien/${operations.results[0].IdMaintenanceplan}`)
            }
          >
            Plan d'entretien
          </WTypography>
        </>
      ) : (
        <>
          {operationsH.results?.length > 0 ? (
            <WTypography
              variant="h6"
              onClick={() =>
                navigate(`/domicile/entretien/${operationsH.results[0].IdMaintenanceplan}`)
              }
            >
              Plan d'entretien
            </WTypography>
          ) : (
            <WTypography variant="h6">Plan d'entretien</WTypography>
          )}
        </>
      )}
      <Box
        className="calendar-container"
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
        }}
      >
        <Box
          className="calendar-box"
          sx={{ width: isMobile ? '100%' : '50%', '#year': { minWidth: '0' } }}
        >
          <CalendarView id={id} page="vehicule" />
        </Box>
        <Box className="calendar-view" sx={{ width: isMobile ? '100%' : '50%' }}>
          <ListTop operations={operations} setEventViewF={setEventViewF} />
          <ListBottom operations={operationsH} setEventF={setEventF} />
        </Box>
      </Box>
      {/* <WTypography> Coming soon</WTypography> */}
    </Box>
  )
  return (
    <>
      <Dialog
        open={upload}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleCloseDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{ backgroundColor: '#202020' }}>Upload Vehicle Image</DialogTitle>

        <VehicleImgUploadForm
          handleClose={handleCloseDialog}
          setFiles={setFiles}
          upload_vehicle_picture={upload_vehicle_picture}
        />
      </Dialog>
      {openAContactForm && (
        <AddContact setOpen={setOpenAContactForm} updateVehicle={fetchVehicleDetail} vid={id} />
      )}
      {open && (
        <UpdateVehicle
          vehicle={vehicule}
          openModel={open}
          setOpenModel={setOpen}
          setVehicule={setVehicule}
          field={field}
          fetchVehicleDetail={fetchVehicleDetail}
        />
      )}
      {eventViewF && <EventViewForm setEventViewF={setEventViewF} row={eventViewF} />}
      {eventF && (
        <CreateEventForm
          setEventF={setEventF}
          fetchOperations={fetchOperations}
          fetchEntretienHistoriques={fetchEntretienHistoriques}
          row={eventF}
        />
      )}
      {vehicule.Marques ? (
        <Container maxWidth="lg">
          <Box display={'flex'} px={4} py={1}>
            <Box
              sx={{
                width: '60%',
                position: 'relative',
                img: {
                  height: '350px',
                },
              }}
              className="vehiculeDetailImg"
            >
              <img
                key="carLogo"
                src={vehicule.car_picture ? vehicule.car_picture : vehicule.Models.carpicture}
                alt="img"
                width={'100%'}
                height="350px !important"
              />
              <FileUploadIcon
                onClick={() => setUpload(true)}
                sx={{
                  position: 'absolute',
                  right: '13px',
                  color: 'white',
                  zIndex: 100,
                  backgroundColor: '#4c4c4c',
                  padding: '3px',
                  fontSize: '30px',
                  borderRadius: '14px',
                  bottom: '5px',
                  cursor: 'pointer',
                }}
              />
            </Box>
            <Box
              ml={4}
              display={'flex'}
              alignItems={'center'}
              flexDirection={'column'}
              justifyContent={'center'}
              sx={{ width: '30%' }}
            >
              <img key="carPic" src={vehicule.Marques.LogoConstruct} alt="img" width={'100%'} />
              <Box marginRight={'auto'}>
                {/* <WTypography variant="h4" sx={{color: 'red'}} textTransform={'capitalize'}>{vehicule.Models.Name}</WTypography> */}
              </Box>
            </Box>
          </Box>
          <WTypography variant="h4">{vehicule.Nom || vehicule.Name}</WTypography>

          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  onChange={handleChange}
                  sx={{ '.MuiTabs-flexContainer': { overflow: 'auto' } }}
                >
                  <Tab sx={{ color: 'white' }} label="Informations générales" value="1" />
                  <Tab sx={{ color: 'white' }} label="Caractéristiques techniques" value="2" />
                  <Tab sx={{ color: 'white' }} label="Informations financières" value="3" />
                  <Tab sx={{ color: 'white' }} label="Contact" value="4" />
                  <Tab sx={{ color: 'white' }} label="Document" value="5" />
                  <Tab sx={{ color: 'white' }} label="Planning entretien" value="6" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <WTypography variant="h6">{informationGenerales}</WTypography>
              </TabPanel>
              <TabPanel value="2">{caracteristiquestechniques}</TabPanel>
              <TabPanel value="3">{informationsfinancieres}</TabPanel>
              <TabPanel value="4">{contact}</TabPanel>
              <TabPanel value="5">{documents}</TabPanel>
              <TabPanel value="6" sx={{ p: isMobile ? 0 : 3 }}>
                {plandentretien}
              </TabPanel>
            </TabContext>
            {/* {informationGenerales}
            {caracteristiquestechniques}
            {informationsfinancieres}
            {contact}
            {documents}
            {plandentretien} */}
          </Box>
        </Container>
      ) : (
        ''
      )}
    </>
  )
}

function AddContact({ vid, updateVehicle, setOpen }) {
  // const [open, setOpen] = useState(false)
  const [contacts, setContacts] = useState([])

  const roles = [
    { id: 1, label: 'Assurance' },
    { id: 2, label: 'Propriétaire ' },
    { id: 3, label: 'Ancien proriétaire' },
    { id: 4, label: 'Garagiste' },
    { id: 5, label: 'Stationnement' },
    { id: 6, label: 'Conducteurs' },
    { id: 7, label: 'Pièces' },
    { id: 8, label: 'Loueur' },
    { id: 9, label: 'Vendeur' },
    { id: 10, label: 'Acheteur' },
  ]

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      contact: '',
      vehicle: vid,
      role: '',
    },
  })

  // const handleClickOpen = () => {
  //   setOpen(true)
  //   fetchContacts()
  // }
  useEffect(() => {
    fetchContacts()
  }, [])
  const fetchContacts = async () => {
    const filterContacts = []
    const { data } = await makeGetRequest('/api/Social/get-all-contacts/', {}, true)
    data.map((v) => {
      filterContacts.push({ label: v.Nom, id: v.id })
      return ''
    })
    setContacts([...filterContacts])
  }
  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      contact: data.contact.id,
      role: data.role.label,
    }

    const response = await makePostRequest(urls.addVContactOp, payload, {}, true)
    if (response.status === 201) {
      updateVehicle()
      handleClose()
    }
  }

  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={true} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Affectation contact</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('contact', j)
              }}
              label="Sélectionner contact"
              data={contacts}
              name="contact"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('role', j)
              }}
              label="Rôles"
              data={roles}
              name="role"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

function BasicTable() {
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(params.id, 20)
  }, [])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      `/api/Administrative/documents-operations/?Vehicledata=${id}`,
      {},
      true,
    )
    if (status === 200) {
      let results = data.results
      setNewRows([...results])
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(params.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(params.id, 20)
        setSelected([])
      }
    }
  }

  return (
    <>
      <Box>
        {/* <Typography variant="h5" pl={3} pt={3} sx={{ color: 'white' }}>
          Related documents
        </Typography> */}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} py={5}>
        <Box>
          <Typography variant="h5" pl={1} sx={{ color: 'white' }}>
            Mes documents ({newRows.length})
          </Typography>
        </Box>
        <Box>
          <CreateDocumentsForm params={params} account="Véhicules" setNewRows={setNewRows} />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      {/* {row.Lien.split('/').pop()} */}
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />
                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.Lien}>
                          {row.Lien.split('/').pop()}
                        </Link>
                        <br />
                        Charge le: {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                        Taille de fichier: {row.FileSize} Mio
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>No data yet.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {/* {newRows.length > 20 && newRows.results.length % 20 === 0 ? ( */}
          {newRows.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>Load More</Button>
            </Box>
          ) : (
            newRows.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(params.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  Return to initial Size
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}
